import React from "react";
import { Moon, Sun, Type } from "lucide-react";

// Quick Dark mode + Large text switches for the dialer header.
export function DialerViewToggles({ prefs, set }) {
  const b = (on) => `shrink-0 rounded-full px-3 py-1.5 text-xs inline-flex items-center gap-1.5 border transition-colors ${on ? "bg-[var(--gold)] border-[var(--gold)] text-black" : "border-[var(--line)] hover:border-[var(--gold)]"}`;
  return <>
    <button onClick={() => set("dark", !prefs.dark)} className={b(prefs.dark)} aria-pressed={!!prefs.dark} data-testid="dialer-dark-toggle">{prefs.dark ? <Sun className="w-3.5 h-3.5" /> : <Moon className="w-3.5 h-3.5" />}{prefs.dark ? "Light mode" : "Dark mode"}</button>
    <button onClick={() => set("large", !prefs.large)} className={b(prefs.large)} aria-pressed={!!prefs.large} data-testid="dialer-large-toggle"><Type className="w-3.5 h-3.5" />Large text</button>
  </>;
}
